import * as React from "react";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render, { RenderDiv } from "source/app/presentation/Shared/Render";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { HandleRenameHashTagRequest } from "./HandleRenameHashTagRequest";

export function RenameHashTagForm({ hashTag }: { hashTag: string }) {
    const [newHashTagName, setNewHashTagName] = React.useState<string>(``);

    return (
        <div>
            <RenderDiv id="newHashTagNameDisplay" when={newHashTagName !== ``}>
                Change <strong>{hashTag}</strong> to{" "}
                <strong>{`#${newHashTagName}`}</strong>
            </RenderDiv>
            <FormInput
                label="new name"
                type="string"
                onChange={(event) => setNewHashTagName(event.target.value)}
                maxWidth="250px"
                displayBlock={false}
                value={newHashTagName}
            />
            <Render id="setNewHashTagName" when={newHashTagName !== ``}>
                <span style={{ margin: `5px` }}>
                    <IconWithText
                        iconSuffix={EGlyphicon.ok}
                        whenClicked={() =>
                            HandleRenameHashTagRequest(
                                setNewHashTagName,
                                hashTag,
                                newHashTagName
                            )
                        }
                        displayAsBlock={false}
                    />
                </span>
            </Render>
        </div>
    );
}
